import SearchFormHotelOffersAutocompleteController from '@/js/desktop/components/searchFormAutocomplete/searchFormHotelOffersAutocompleteController';
import tourCriteriaService from '@/js/common/Domain/Service/tourCriteria';
import toLocalStorageTourCriteriaHydrator from '@/js/common/Domain/Hydrator/toLocalStorageTourCriteria';
import SearchRouter from '@/js/common/Domain/Router/SearchRouter';
import searchHistoryService from '@/js/common/Domain/Service/searchHistory';
import ls from 'local-storage';

import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';

export default class extends SearchFormHotelOffersAutocompleteController {
    loadTourCriteriaWithFormData(params) {
        const success = (tourCriteria) => {
            const hotel = new Backbone.Model({
                id: window.appConfig.hotel.id,
                name: window.appConfig.hotel.name,
                category: window.appConfig.hotel.category,
            });

            const hotels = new Backbone.Collection([hotel]);
            tourCriteria.set('hotels', hotels);

            this.model.setTourCriteria(tourCriteria, true);
        };

        tourCriteriaService.loadTourCriteriaWithFormData(params, {
            success: success.bind(this),
            error(tourCriteria) {},
        });
    }

    formSubmit() {
        const currentTourCriteria = this.model.getTourCriteria();
        const paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(currentTourCriteria);
        const router = new SearchRouter().getInstance();

        if (currentTourCriteria.isValid() && this.searchFormView.isValid()) {
            $.cookie('requestFromMainPage', true, { path: '/', domain: 'all' });
            $.cookie('markSearchSource', true, { path: '/', domain: 'all' });

            ls.set('tourCriteria__hotelOffers', paramsForLocalStorage);

            searchHistoryService.addSearch(currentTourCriteria);

            if (currentTourCriteria.get('hotels') && currentTourCriteria.get('hotels').length === 1) {
                const paramsForRouter = toRouterHotelHydrator({ tourCriteria: currentTourCriteria });
                const goToUrl = `/goto/hotel/${currentTourCriteria.get('hotels').at(0).get('id')}#?${$.param(paramsForRouter)}`;

                router.go(goToUrl, null, true);
            }

            this.dataLayerAnalytics.clickSearchButtonEvent();
        }
    }
}